/**
 * 로그인 뒤 돌아갈 주소 — 같은 사이트 안의 경로만 받는다(열린 리디렉트 방지).
 * 주소로 바로 연 화면·세션 만료로 튕긴 화면을 로그인 뒤 다시 보여 주는 데 쓴다(A3-28).
 */
export function safeReturnPath(value: unknown): string | null {
  if (typeof value !== "string") return null;
  if (!value.startsWith("/") || value.startsWith("//")) return null;
  if (value.startsWith("/login")) return null;
  return value;
}
